
export default {
  state: {
    inApp: false,
    systemInfo: {}
  },
  mutations: {
    setSystem(state, data) {
      state.inApp = true
      state.systemInfo = data
    }
  },
  getters: {
    inApp: state => {
      return state.inApp
    },
    getSystemInfo: state => {
      return state.systemInfo
    }
  },
  actions: {
    setSystemInfo({ commit }, data) {
      return new Promise(resolve => {
        const { statusBarHeight = 0, navigationHeight = 0 } = data || {}
        if (statusBarHeight > 0) {
          commit('setStatusBarHeight', statusBarHeight)
        }
        if (navigationHeight > 0) {
          commit('setNavigationBarHeight', navigationHeight)
        }
        commit('setSystem', data)
        resolve(data)
      })
    }
  }
}
